import { Textarea } from '@/components/uiKit/FormControl';
import React from 'react';
import { Controller } from 'react-hook-form';
export const TextareaField = ({
  name,
  label,
  control,
  errors,
  disabled = false,
  dataTestId
}: {
  name: string;
  label: string;
  control: any;
  errors: any;
  disabled?: boolean;
  dataTestId?: string;
}) => (
  <div className="flex flex-col">
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <Textarea
            {...field}
            disabled={name !== 'component' && name !== 'comments'}
            grow
            label={label}
            value={field.value}
            onChange={field.onChange}
            error={errors[name]?.message}
            dataTestId={dataTestId}
          />
        </>
      )}
    />
    {/* Display error message if there is an error */}
    {errors[name] && <p className="text-critical text-xs ml-2">{errors[name]?.message}</p>}
  </div>
);
